import { Bath, Bedding } from "./bed-and-bath"
import { Bedroom, Benches, DiningRoom, Entry, LivingRoom, Office } from "@layouts/categories/furniture"

import {
  CookwareAndBakeware,
  DecorativeKitchenAccessories,
  KitchenStorage,
  Tabletop,
} from "@layouts/categories/kitchen"

import {
  FirePitsAndTables,
  OutdoorAccents,
  OutdoorFurniture,
  OutdoorLighting,
  OutdoorRugsAndDoormats,
} from "@layouts/categories/outdoor"
import { CeilingLightsAndFans, TableAndFloorLamps, WallLighting } from "@layouts/categories/lighting"
import { HomeAccents, PillowsAndThrows } from "@layouts/categories/pillows-and-decor"
import { AllRugsAndPads } from "@layouts/categories/rugs"
import { FloorMirrors, Photography, WallAccents, WallArt, WallMirrors } from "@layouts/categories/wall-art-and-mirrors"
import { Brand, EndUse, Material, Pattern } from "@layouts/categories/fabric"
import { Brand as WallcoveringBrand, WallcoveringMaterial, WallcoveringPattern } from "@layouts/categories/wallcovering"

export interface RouteParams {
  [key: string]: (string | number)[]
}

export interface MenuItem {
  name: string
  path?: string
  routeParams?: RouteParams
  children?: MenuItem[]
}

export interface Menu {
  name: string
  routeParams: RouteParams
  columns: MenuItem[][]
  classes: string
}

/**
 * See also: VirtualCollection
 */
const menus: Menu[] = [
  {
    name: "Living",
    columns: [
      [LivingRoom, Office],
      [Entry, Benches],
    ],
    routeParams: {
      categories: ["furniture.living-room", "furniture.office", "furniture.entry", "furniture.benches"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Dining",
    columns: [[DiningRoom]],
    routeParams: {
      categories: ["furniture.dining-room"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Bedroom",
    columns: [[Bedroom, Bedding], [PillowsAndThrows]],
    routeParams: {
      categories: ["furniture.bedroom", "bed-bath.bedding", "pillows-decor.pillows-throws"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Lighting",
    columns: [
      [CeilingLightsAndFans, WallLighting],
      [TableAndFloorLamps, OutdoorLighting],
    ],
    routeParams: {
      categories: ["lighting", "outdoor.outdoor-lighting"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Fabric",
    columns: [[Brand, Pattern, Material, EndUse]],
    routeParams: {
      categories: ["fabric"],
    },
    classes: "grid-cols-[repeat(2,1fr)] lg:grid-cols-[repeat(4,1fr)]",
  },
  {
    name: "Wallcovering",
    columns: [[WallcoveringBrand, WallcoveringPattern, WallcoveringMaterial]],
    routeParams: {
      categories: ["wallcovering"],
    },
    classes: "grid-cols-[repeat(2,1fr)] lg:grid-cols-[repeat(3,1fr)]",
  },
  {
    name: "Outdoor",
    columns: [
      [OutdoorFurniture, OutdoorAccents, OutdoorRugsAndDoormats],
      [FirePitsAndTables, OutdoorLighting],
    ],
    routeParams: {
      categories: ["outdoor"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Rugs",
    columns: [[AllRugsAndPads]],
    routeParams: {
      categories: ["rugs"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Pillows & Accessories",
    routeParams: {
      categories: ["pillows-decor"],
    },
    columns: [[PillowsAndThrows, HomeAccents]],
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Art & Mirrors",
    columns: [[WallArt, WallAccents, Photography, WallMirrors, FloorMirrors]],
    routeParams: {
      categories: ["wall-art-mirrors"],
    },
    classes: "grid-cols-[repeat(2,1fr)]",
  },
  {
    name: "Kitchen & Bath",
    routeParams: {
      categories: ["kitchen", "bed-bath.bath"],
    },
    columns: [[Tabletop], [CookwareAndBakeware, KitchenStorage, DecorativeKitchenAccessories, Bath]],
    classes: "grid-cols-[repeat(2,1fr)]",
  },
]

export default menus
